import React, { useLayoutEffect, useRef } from "react";

const textStyle = {
	fontFamily: "monospace",
	fontSize: "14px",
	fontWeight: 400,
	fontStyle: "normal",
	lineHeight: "22px",
	letterSpacing: "normal",
	textAlign: "left",
	tabSize: 4,
	padding: "8px 10px",
	boxSizing: "border-box",
	whiteSpace: "pre-wrap",
	overflowWrap: "break-word",
	wordBreak: "normal",
};

function GamesSectionGameIdsInput({ value, tokens, disabled, onChange, id, describedBy, hasError }) {
	const inputRef = useRef(null);
	const mirrorRef = useRef(null);

	const syncMirror = () => {
		const input = inputRef.current;
		const mirror = mirrorRef.current;
		mirror.style.width = `${input.clientWidth}px`;
		mirror.style.height = `${input.clientHeight}px`;
		mirror.scrollTop = input.scrollTop;
		mirror.scrollLeft = input.scrollLeft;
	};

	useLayoutEffect(() => {
		const observer = new ResizeObserver(syncMirror);
		observer.observe(inputRef.current);
		syncMirror();
		return () => observer.disconnect();
	}, []);

	useLayoutEffect(syncMirror, [value]);

	const highlightedText = [];
	let position = 0;
	tokens.forEach((token) => {
		highlightedText.push(value.slice(position, token.start));
		highlightedText.push(
			<span key={token.start} style={{ color: ["invalid", "unknown", "unavailable"].includes(token.status) ? "#d91515" : "#16191f" }}>
				{value.slice(token.start, token.end)}
			</span>,
		);
		position = token.end;
	});
	highlightedText.push(value.slice(position));

	return (
		<div style={{ position: "relative", background: disabled ? "#f2f3f3" : "#fff", borderRadius: "4px" }}>
			<div ref={mirrorRef} aria-hidden="true" style={{ position: "absolute", top: "1px", left: "1px", overflow: "hidden", pointerEvents: "none", color: "#16191f" }}>
				<pre style={{ ...textStyle, margin: 0, border: 0, minHeight: "100%", width: "100%", color: "#16191f" }}>
					{highlightedText}{!value || value.endsWith("\n") ? "\u200b" : ""}
				</pre>
			</div>
			<textarea
				ref={inputRef}
				id={id}
				aria-label="Game IDs"
				aria-describedby={describedBy}
				aria-invalid={hasError}
				value={value}
				disabled={disabled}
				spellCheck={false}
				wrap="soft"
				onChange={(event) => onChange(event.target.value)}
				onScroll={syncMirror}
				style={{ ...textStyle, position: "relative", zIndex: 1, display: "block", width: "100%", height: "194px", minHeight: "106px", margin: 0, border: "1px solid #879596", borderRadius: "4px", background: "transparent", color: "transparent", WebkitTextFillColor: "transparent", caretColor: "#16191f", resize: "vertical", overflow: "auto" }}
			/>
		</div>
	);
}

export default GamesSectionGameIdsInput;
